import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import Dashboard from './dashboard';

const enhance = compose(
	withState('inputError', 'setInputError', false),
	withHandlers({
		handlePNInputChange: props => event => {
			const {pageNumbers} = props;
			const val = event.target.value;

			let num = parseInt(val, 10);

			if (window.isNaN(num) && val !== '') {
				props.setInputError(true);
				return;
			} else if (num > pageNumbers) {
				num = pageNumbers;
			} else if (num < 0) {
				num = 0;
			} else if (val === '') {
				props.setPageNumber('');
				return;
			}

			props.setInputError(false);
			props.setPageNumber(num);
		},
		handleNextPage: props => () => {
			const {pageNumber, pageNumbers, setPageNumber} = props;
			const parsedNum = parseInt(pageNumber, 10);
			const parsedCount = parseInt(pageNumbers, 10);

			setPageNumber(parsedNum >= parsedCount ? parsedCount : parsedNum + 1);
		},
		handlePrevPage: props => () => {
			const {pageNumber, setPageNumber} = props;
			const parsed = parseInt(pageNumber, 10);

			setPageNumber(parsed <= 1 ? 1 : parsed - 1);
		},
		handleFullscreen: props => () => {
			props.setFullscreen(true);
		}
	}),
	mapProps(({setInputError, setFullscreen, ...rest}) => ({...rest}))
);

export default enhance(Dashboard);



// WEBPACK FOOTER //
// ./src/client/components/main/files/pdf-viewer-dashboard/index.js